export const classifierGroups = {
    badges: 'Badges',
};
